import { ArrowRight } from "lucide-react";
import type { HomeCategory } from "@/src/data/home";

type CategoryPillsProps = {
  categories: HomeCategory[];
};

export function CategoryPills({ categories }: CategoryPillsProps) {
  return (
    <nav
      aria-label="Produktkategorien"
      className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3"
    >
      {categories.map((category) => (
        <a
          key={category.id}
          href={category.href}
          className="home-focus group relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white/74 p-4 shadow-[0_10px_24px_rgba(30,41,59,0.09)] transition hover:-translate-y-1 hover:border-cyan-500/35 hover:bg-white/92"
        >
          <span className="pointer-events-none absolute -right-8 -top-8 h-20 w-20 rounded-full bg-cyan-300/24 blur-2xl transition group-hover:bg-cyan-300/34" />
          <div className="relative">
            <div className="flex items-center justify-between gap-3">
              <span className="font-semibold text-slate-900">
                {category.label}
              </span>
              <ArrowRight className="h-4 w-4 text-slate-500 transition group-hover:translate-x-0.5 group-hover:text-cyan-700" />
            </div>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              {category.description}
            </p>
            <span className="mt-3 inline-flex rounded-full border border-slate-300/75 bg-white/80 px-2.5 py-1 text-[11px] uppercase tracking-[0.08em] text-slate-600">
              {category.count} Produkte
            </span>
          </div>
        </a>
      ))}
    </nav>
  );
}
